
export const useDumper = () => {

    const data = async (config) => {

        const nowFileString = new Date().toISOString().split(".")[0].replaceAll(":", "-")

        if (! ("data" in config)) {
            console.error("data is required")
            return
        }
        if (! ("fileName" in config)) {
            config.fileName = `file_now.json.txt`
        }
        if (config.fileName.indexOf("_now") != -1) {
            config.fileName = config.fileName.replaceAll("_now", "_" + nowFileString)
        }
        if (! ("type" in config)) {
            config.type = "text/plain"
        }
        if (! ("title" in config)) {
            config.title = "Export data"
        }
        if (! ("text" in config)) {
            config.text = "Some data"
        }

        const files = []

        const blob = new Blob([JSON.stringify(config.data, null, 4)])
        const dataStoreFileTxt = new File([blob], config.fileName, { type: config.type })

        files.push(dataStoreFileTxt)

        const sharingObject = {
            title: config.title,
            text: config.text,
            files: files,
        }

        // const sharingObject = {
        //     title: "wholeDataStore",
        //     text: "il contenuto di tutto il dataStore",
        //     files: files,
        //   }

        if (navigator?.canShare)
            if (navigator?.canShare(sharingObject)) {
                try {
                    await navigator.share(sharingObject)
                } catch (err) {
                    if (err.name !== 'AbortError') {
                        console.error(err.name, err.message)
                    }
                } finally {
                    return
                }
            }

        // Fallback implementation.
        const a = document.createElement('a')
        a.download = config.fileName
        a.style.display = 'none'
        a.href = URL.createObjectURL(blob)
        a.addEventListener('click', () => {
            setTimeout(() => {
                URL.revokeObjectURL(a.href)
                a.remove()
            }, 1000)
        })
        document.body.append(a)
        a.click()

    }

    return {
        data,
    }
}



